import * as React from "react";
const Report = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="#4092FF"
      fillRule="evenodd"
      d="M24.8 0 31 6.2v18.6H0V0h24.8Zm-.775 3.1H3.1v18.6h24.8V6.975L24.025 3.1ZM7.75 6.2v9.61l4.436-5.546 4.738 2.369 3.483-3.134 1.036 1.152-4.267 3.84-4.564-2.28-3.87 4.839H24.8v1.55H6.2V6.2h1.55Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Report;
